import { Organization } from "./organization";

export type AccountType = "consultant" | "sentinel" | "grower";

export enum AccessLevel {
    SENTINEL = "sentinel",
    SUMMARY = "summary",
    DETAIL = "detail",
}

export enum Resource {
    SI_TRENDLINE = "si_trendline",
    SI_BAR = "si_bar",
    VIRTUAL_SI = "virtual_si",
    GENERATE_RX = "generate_rx",
    GROWTH_MODEL = "growth_model",
    INSIGHTS_CONFIGURATION = "insights_configuration",
    MANUALLY_ADD_PLOTS = "manually_add_plots",
    SIMULATE_RX = "simulate_rx",
    SOIL_PROPERTIES = "soil_properties",
    TISSUE_PROPERTIES = "tissue_properties",
    MANAGEMENT_ZONES = "management_zones",
    TREATMENT_SECTORS = "treatment_sectors",
    IMAGERY_TIMELINE = "imagery_timeline",
    TOUR = "tour",
    IRRIGATION = "irrigation",
}

export type User = {
    old_id?: string;
    crm_id?: string;
    leaf_id?: string;
    is_group_admin: boolean | false;
    primary_consultant: object;
    account_type: AccountType;
    address_1?: string;
    address_2?: string;
    city?: string;
    state?: string;
    zip?: string;
    email: string;
    first_name: string;
    last_name: string;
    full_name: string;
    id: number;
    is_active: boolean;
    is_staff: boolean;
    organization?: string | Organization;
    phone_number?: string;
    user_permissions?: Array<object>;
    username: string;
    agreed_to_terms: boolean;
    provider: "";
    mobile_id?: string;
    send_text_notifications?: boolean;
    send_email_notifications?: boolean;
    send_push_notifications?: boolean;
    timezone?: string;
    days_to_notify?: number[];
    notification_delivery_time_1?: string;
    language_preference?: string;
    unit_preference?: "imperial" | "metric";
    date_format?: "month_day_year" | "day_month_year" | "year_month_day";
    access_control: Record<Resource, AccessLevel>;
};

export type UserDefaults = {
    application_cost: number;
    nitrogen_cost: number;
    crop_price: number;
};
